export const DATATABLE_CUSTOM_STYLES={
    table: {
        style: {}
    },
    /*tableWrapper: {
        style: CSSObject
    },
    responsiveWrapper: {
        style: CSSObject
    },
    header: {
        style: CSSObject
    },
    subHeader: {
        style: CSSObject
    },
    head: {
        style: CSSObject
    },*/
    headRow: {
        style: {
            borderLeft: "4px solid #FFFFFF",
        }
    },
    headCells: {
        style: {
          color:"#212529",
          fontWeight:"bold",
          fontSize: "1rem",
          marginLeft: "2px !important",
        }
    },
    /*contextMenu: {
        style?: CSSObject
        activeStyle?: CSSObject
    },*/
    cells: {
        style: {
          
          marginLeft: "2px !important",
          color: "#212529",
          fontSize: "1rem",
          //backgroundColor: "red"
          
        }
    },
    rows: {
        style: {
          borderBottom: "none !important",
          backgroundColor: "#FFFFFF",
          paddingLeft: "0px",
          borderLeft: "4px solid #FFFFFF",
          //background: "none !important"
        },
        selectedHighlightStyle: {
          backgroundColor: "#D7E8F7 !important",
          borderLeft: "4px solid #005EA2",
          paddingLeft: "0px"
        },
        //denseStyle?: CSSObject
        //highlightOnHoverStyle?: CSSObject
        stripedStyle: {
          backgroundColor: "#f2f2f2",
          borderLeft: "4px solid #f2f2f2",
          //background: "none !important"
        }
    },
    expanderRow: {
        style: {
            borderBottom: "none !important",
            backgroundColor: "rgba(0, 94, 162, 0.1) !important",
            paddingLeft: "0px",
          }
    },
    expanderCell: {
        style: {
          
            marginLeft: "2px !important",
            color: "#212529",
            fontSize: "1rem",
            //backgroundColor: "red"
            
          }
    },
    expanderButton: {
        style: {}
    },
    /*noData: {
        style: CSSObject
    },
    progress: {
        style: CSSObject
    }*/
}

/*export const DATATABLE_SELECTED_STYLE = ({ selectedRows}) => {
    
    return [{
        when: (row) => {
            if((selectedRows).some(i => i.id == row.id)){
                return true
            }
            else{
                return false
            }
        },
        style: {
            boxShadow: "-2px 0px 0px 0px white, 2px 0px 0px 0px white",
        },
        classNames: ['selected-row']
    }]
};*/

export const DATATABLE_CUSTOM_STYLES_STATIC={
    table: {
        style: {}
    },
    /*tableWrapper: {
        style: CSSObject
    },
    responsiveWrapper: {
        style: CSSObject
    },
    header: {
        style: CSSObject
    },
    subHeader: {
        style: CSSObject
    },
    head: {
        style: CSSObject
    },*/
    headRow: {
        style: {
            borderLeft: "0px solid #193F64",
            background: '#193F64',
            padding: "0px !important",
            columnGap: "3px"
        }
    },
    headCells: {
        style: {
          justifyContent: 'center',
          color:"white",
          fontWeight:"600",
          fontSize: "1rem",
          marginLeft: "3px !important",
          marginRight: "3px !important",
          textAlign: "center",
          padding: "0px !important"
        }
    },
    /*contextMenu: {
        style?: CSSObject
        activeStyle?: CSSObject
    },*/
    cells: {
        style: {
          justifyContent: 'center',
          marginLeft: "0px !important",
          color: '#212529',
          fontSize: "1.1rem",
          textAlign: "center",
          fontWeight:"500"
          //backgroundColor: "red"
          
        }
    },
    rows: {
        style: {
          borderBottom: "none !important",
          backgroundColor: "#FFFFFF",
          paddingLeft: "0px",
          borderLeft: "0px solid #FFFFFF",
          columnGap: "3px"
          //background: "none !important"
        },
        selectedHighlightStyle: {
          backgroundColor: "#D7E8F7 !important",
          borderLeft: "0px solid #005EA2",
          paddingLeft: "0px"
        },
        //denseStyle?: CSSObject
        //highlightOnHoverStyle?: CSSObject
        stripedStyle: {
          backgroundColor: "#f2f2f2",
          borderLeft: "4px solid #f2f2f2",
          //background: "none !important"
        }
    },
    expanderRow: {
        style: {
            borderBottom: "none !important",
            backgroundColor: "rgba(0, 94, 162, 0.1) !important",
            paddingLeft: "0px",
          }
    },
    expanderCell: {
        style: {
          
            marginLeft: "2px !important",
            color: "#212529",
            fontSize: "1rem",
            //backgroundColor: "red"
            
          }
    },
    expanderButton: {
        style: {}
    },
    /*noData: {
        style: CSSObject
    },
    progress: {
        style: CSSObject
    }*/
}